export const clinicNetworkTypes = {
  HUB: 'hub',
  SPOKE: 'spoke',
  NO_TYPE: ''
};
